/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proud_Inner_Wolf_SpurInputs */

const fr_proud_inner_wolf_spur = /** @type {(inputs: Proud_Inner_Wolf_SpurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes vous sur de vouloir supprimer cet utilisateur ? Il ne sera plus visible dans la liste des utilisateurs et ne pourra plus se connecter.`)
};

/**

* @param {Proud_Inner_Wolf_SpurInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const proud_inner_wolf_spur = /** @type {((inputs?: Proud_Inner_Wolf_SpurInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proud_Inner_Wolf_SpurInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_proud_inner_wolf_spur(inputs)
});